import http from "../http-common"

const getAll = () => {
	return http.get(`/v1/menus/`)
}

const get = id => {
	return http.get(`/v1/menus/id/${id}`)
}

const create = data => {
	return http.post("/v1/menus", data)
}

const update = (id, data) => {
	return http.put(`/v1/menus/${id}`, data)
}

const remove = id => {
	return http.delete(`/v1/menus/${id}`)
}

const removeAll = () => {
	return http.delete(`/v1/menus`)
}

const findByName = name => {
	return http.get(`/v1/menus?name=${name}`)
}

export default {
	getAll,
	get,
	create,
	update,
	remove,
	removeAll,
	findByName,
}
